import PropTypes from"prop-types";export const Variants=["new","deal","oos"];const propTypes={variant:PropTypes.oneOf(Variants)};export default propTypes;